import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import NurseIcon from '@/components/ui/icons/Nurse'

type RoomProps = {
  id: string
  name: string
  status: string
}

export function Room(props: RoomProps) {
  const { id, name, status } = props
  const { t } = useTranslation()

  const [isHovering, setIsHovering] = useState<boolean>(false)

  const handleMouseEnter = () => {
    setIsHovering(true)
  }

  const handleMouseLeave = () => {
    setIsHovering(false)
  }

  return (
    <Stack alignItems="center" justifyContent="center" spacing={1}>
      <Paper
        component="div"
        data-testid="avatar"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
          width: 96,
          height: 96,
          borderRadius: '100%',
          boxShadow: '0px 0px 16px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '&:hover': {
            backgroundColor: 'primary.light',
          },
        }}
      >
        {!isHovering ? (
          <NurseIcon fontSize="large" />
        ) : (
          <Button color="secondary" component={Link} to={`/emergencies/${id}`} size="small" variant="contained">
            {t('common:button.join.label')}
          </Button>
        )}
      </Paper>
      <Typography>{name}</Typography>
      <Chip color="primary" label={status} size="small" variant="filled" />
    </Stack>
  )
}

export default Room
